module.exports = __webpack_public_path__ + "img/image-02.0ece066c.jpg";